<style>
.form-error{
  color:red;
  margin-left:33px;
  margin-top:-14px
}
</style>


<template>
  <v-layout row justify-center>

    <v-dialog 
      lazy :hide-overlay="(shadow==undefined)?shadow:!shadow" persistent :width="$vuetify.breakpoint.sm? '100%' : '60%'" @keydown.esc="reject"  v-model="dialog">

      <v-card>
        <v-form ref="newDeviceForm" v-on:submit.prevent="submit"> 
          <v-card-title style="background-color:#002052"> 
            <v-icon color="white" style="margin-right:0.5rem">{{form.icon}}</v-icon>
            <span class="headline white--text">{{form.title}}</span>
          </v-card-title>

          <v-card-text>

            <v-container grid-list-md>

              <v-layout wrap>
                <div v-for="(data, i) in form.formStruct" :key="i" style="width:100%">
                  <v-flex v-if="checkIfField(model,data)" xs12 sm12 md12 style="position:relative">
                    <v-tooltip bottom 
                            v-if="(data.type=='text'||data.type=='password')&&checkIfField(model,data)/*((data.if)?(model[data.if[0].key]==data.if[0].value):true)*/" 
                            v-show="(data.show==false)?false:true">
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          
                          <!-- 'required:'+(data.validator.required==true)+ -->
                          <v-text-field 
                            color="#39a9dc"
                            :ref="data.name" 
                            :label="data.label" 
                            :prepend-icon="data.icon"
                            v-validate="'required:'+data.validator.required+'|min:'+data.validator.min+'|max:'+data.validator.max+'|regex:'+modelConstrains[data.name+'--regexp']"
                            :counter="data.validator.max" 
                            v-model="model[data.name]" 
                            :name="data.name" 
                            :type="data.type"
                            :error="errors.first(data.name)!=undefined"
                          >
                          </v-text-field>
                        </span>
                      </template>
                      <span>{{data.hint}}</span>
                    </v-tooltip>


                    <v-tooltip bottom 
                            v-if="(data.type=='textarea')&&checkIfField(model,data)/*((data.if)?(model[data.if[0].key]==data.if[0].value):true)*/" 
                            v-show="(data.show==false)?false:true">
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          
                          <!-- 'required:'+(data.validator.required==true)+ -->
                          <v-textarea 
                            color="#39a9dc"
                            v-validate=" '|required:'+(data.validator.required==true)+((modelConstrains[data.name+'--regexp']=='json')?'|json':(modelConstrains[data.name+'--regexp']?('|regex:'+modelConstrains[data.name+'--regexp']):''))"
                            box
                            :ref="data.name" 
                            :label="data.label" 
                            :prepend-icon="data.icon"
                            v-model="model[data.name]" 
                            :name="data.name" 
                            :type="data.type"
                            :error="errors.first(data.name)!=undefined"
                          >
                          </v-textarea>
                        </span>
                      </template>
                      <span>{{data.hint}}</span>
                    </v-tooltip>

                    <v-tooltip bottom v-else-if="
                      data.type=='select' &&
                      checkIfField(model,data)
                    ">

                      <!-- ((data.if)?(model[data.if[0].key]==data.if[0].value):true) -->
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          <v-select 
                            color="#39a9dc"
                            v-show="(data.show==false)?false:true"
                            :prepend-icon="data.icon"
                            :items="
                                data
                                .select
                                .concat((data.path)?contextData[data.path]:[])
                                .filter(d=> checkItemIfField(model,d))
                            "
                            :label="data.label"
                            item-value="ref"
                            item-text="text"
                            v-model="model[data.name]"
                            v-validate="data.validator.required?'required':''"
                            :ref="data.name" 
                            >
                          </v-select>
                        </span>
                      </template>
                      <span>{{data.hint}}</span>
                    </v-tooltip>

                    <div v-show="errors.first(data.name)&&((data.show==false)?false:true)" class="form-error caption" style="text-align:left">{{errors.first(data.name)}}</div>

                    <v-flex 
                      xs12 sm12 md12
                      style="margin-top:-10px"
                      v-if="data.validator.regex.alternativeRegexp&&data.type=='text'"
                      v-show="(data.show==false)?false:true"
                    >
                      <v-switch
                        color="#39a9dc"
                        v-model="modelConstrains[data.name+'--alternativeDefault']"
                        :ref="data.name+'--regexp'" 
                        v-on:change="
                          modelConstrains[data.name+'--regexp']= (!$event)?
                                        data.validator.regex.defaultRegexp.value:
                                        data.validator.regex.alternativeRegexp.value
                        "
                        :label="data.validator.regex.alternativeRegexp.label"
                      >
                      </v-switch>
                    </v-flex>


                    <password v-if="data.meter" v-show="(data.show==false)?false:true" class="meter-password" v-model="model[data.name]" :strength-meter-only="true"/>

                    <v-radio-group 
                      v-if="(data.type=='option')&&checkIfField(model,data)/*((data.if)?(model[data.if[0].key]==data.if[0].value):true)*/"
                      :disabled="modelConstrains[data.name+'--disabled']"
                      :ref="data.name" 
                      v-model="model[data.name]"
                      :label="data.label"
                      :prepend-icon="data.icon"
                      v-show="(data.show==false)?false:true"
                    >
                        <v-tooltip right v-for="(item,index) in  (data.select.concat(data.path?contextData[data.path]:[]))" :key="index">
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-radio style="float:left"
                                color="#39a9dc"
                                :label="`${item.text}`"
                                :value="item.ref"
                              ></v-radio>
                              <a v-if="item.routing" style="float:left;margin-top:0.4rem" class="caption"
                              v-on:click="$emit('routing', item.routing)"
                              >{{item.routing.label}}</a>
                            </div>
                          </template>
                          <span>{{item.hint}}</span>
                        </v-tooltip>

                    </v-radio-group>


                    <v-layout 
                      xs12
                      v-if="data.type=='file'"
                    >
                      <!-- <v-flex xs3>
                        <v-btn dark icon class="blue" v-on:click="$refs['setting_upload_file'].click()">
                          <v-icon>add</v-icon>
                        </v-btn>
                      </v-flex> -->
                      <v-flex xs12>
                        <v-text-field 
                          color="#39a9dc"
                          :label="data.label" 
                          :prepend-icon="data.icon"
                          v-validate="'required:'+data.validator.required"
                          v-model="model[data.name+'--hidden']" 
                          :name="data.name" 
                          :error="errors.first(data.name)!=undefined"
                          :disabled="true"
                        >
                        </v-text-field>
                        <input 
                          type="file" 
                          :ref="data.name+'--file'" 
                          :id="data.name+'--file'"
                          v-on:change="uploadFile(data.name)"
                          style="margin-top:-1.5rem"
                        />
                      </v-flex>

                    </v-layout>
                    <v-btn icon v-if="data.randgen" v-on:click="randomGenerator(data)" style="position:absolute;right:0;top:0.3rem">
                      <v-icon color="purple darken-1">sync</v-icon>
                    </v-btn>
                  </v-flex>
                </div>
              </v-layout>

            </v-container>

          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="!form.block" color="red darken-1" flat @click="reject">Close</v-btn>
            <v-btn color="amber darken-1" flat @click="reset">Reset</v-btn>
            <v-btn type="submit" color="#002052" flat @click="submit">Submit</v-btn>
          </v-card-actions>
        </v-form>

      </v-card>
    </v-dialog>

  </v-layout>

</template>

<script>
import Vue from 'vue'
import Password from 'vue-password-strength-meter';
import RandExp from 'randexp'; 

export default {
  name: "form-dialog",
  props:{
    form: Object,
    dialog: Boolean,
    shadow: Boolean,
    contextData: Object
  },

  data() {
    return {
      submitted: false,
      model: {},
      modelConstrains: {}
    }
  },
  components: {
    Password
  },

  created(){
    this.form.formStruct.forEach(
      (field)=>{
        Vue.set( this.model, field.name, (!this.model[field.name])?field.default:this.model[field.name] )
        
        Vue.set(this.modelConstrains,field.name+"--regexp",field.validator.regex.value)
        Vue.set(this.modelConstrains,field.name+"--alternativeDefault",(field.validator.regex.alternativeRegexp)?field.validator.regex.alternativeRegexp.default:undefined)

        this.$watch(
          'model.'+field.name,
          ()=>{
            this.model[field.name]=(field.validator.regex.autoUpperCase)?this.model[field.name].toUpperCase():this.model[field.name]
            this.model[field.name]=(field.validator.regex.autoLowerCase)?this.model[field.name].toLowerCase():this.model[field.name]
            //window.console.log(this.model)
            if(field.disableIfDefined){
              Vue.set(this.modelConstrains,field.disableIfDefined.field+"--disabled",(this.model[field.name])?true:false)
              Vue.set(this.model,field.disableIfDefined.field,field.disableIfDefined.value)
            }
          }
        )      
      
      }
    )
  },

  mounted(){
  },
  methods: {

    randomGenerator(dataField){
      this.model[dataField.name] = new RandExp(dataField.validator.regex.value).gen()
    },

    checkIfField: function(model, data){
      // window.console.log(data)
      if(data.if){
        let visible = (data.if[0].operator=="and")?true:false
        data.if.forEach(
          (ifField) => {
            if(ifField.operator=="and")
              visible = (model[ifField.key]==ifField.value) && visible
            else
              visible = (model[ifField.key]==ifField.value) || visible
          }
        )
        if(visible==false)
          model[data.name] = undefined
        return visible
      }else
        return true

    },

    checkItemIfField: function(model, item){
        if(item.if)
          return model[item.if.key]==item.if.value
        else
          return true
    },

    uploadFile: function(fieldName){
      let file = document.getElementById(fieldName+'--file').files[0]
      let reader = new FileReader()
      reader.vuecontext = this
      reader.onload = function () {
          let arrayBuffer = this.result
          let fileTypedArray = new Uint8Array(arrayBuffer)
          let fileNormalArray = Array.prototype.slice.call(fileTypedArray)
          
          reader.vuecontext.model[fieldName] = {
            name: file.name,
            file: fileNormalArray           
          }
          
      }
      reader.readAsArrayBuffer(file)
      Vue.set(this.model, fieldName+'--hidden',  file.name)
    },


    reject() {
      if(!this.form.block) {
        this.$emit('rejectForm');
        this.$destroy();
      }
    },

    reset(){
      this.$refs.newDeviceForm.reset()
    },
    submit() {

      this.submitted = true;

      this.$validator.validate().then(valid => {
        
        if(valid) {

          if(this.form.confirm) {
            if(this.model[this.form.confirm.field1] === this.model[this.form.confirm.field2]) {

              for(let i in this.model){
                if(this.modelConstrains[i+"--autoUpperCase"]==true)
                  this.model[i] = this.model[i].toUpperCase()
                if(this.modelConstrains[i+"--autoLowerCase"]==true)
                  this.model[i] = this.model[i].toLowerCase()
              }

              this.$emit('submitForm', this.model)
            }
            else {
              this.errors.add({
                field: this.form.confirm.field2,
                msg: 'The ' + this.form.confirm.field1.charAt(0).toUpperCase() + this.form.confirm.field1.slice(1) +
                  ' value must be the same as ' + this.form.confirm.field2.charAt(0).toUpperCase() +
                  this.form.confirm.field2.slice(1)
              })
            }
          }
          else {

            for(let i in this.model){
              if(this.modelConstrains[i+"--autoUpperCase"]==true)
                this.model[i] = this.model[i].toUpperCase()
              if(this.modelConstrains[i+"--autoLowerCase"]==true)
                this.model[i] = this.model[i].toLowerCase()
            } 
            this.$emit('submitForm', this.model)

          }

        }
      })
    }
  }
}
</script>

<style scoped>
  .meter-password {
    margin-left: 33px !important;
  }
</style>